import { Box, InlineFeedback } from '@zillow/constellation-10';

const DEFAULT_BODY_TEXT = 'Base rent should be based on the price of a standard, 12-month lease';

type Props = {
  bodyText?: string;
  marginBottom?: string;
  marginTop?: string;
};

const InlineStaticAlert = ({ bodyText = DEFAULT_BODY_TEXT, marginBottom = '0', marginTop = '0' }: Props) => {
  return (
    <Box css={{ marginBottom, marginTop, display: 'flex', gap: '200' }}>
      <InlineFeedback>{bodyText}</InlineFeedback>
    </Box>
  );
};

export default InlineStaticAlert;
